import { Modal } from 'AppReact';
import { ContentWrapper, OuterWrapper } from './../common/wrappers'


export default Modal({
  outerWrapper: OuterWrapper,
  contentWrapper: ContentWrapper,
  isOpen: ({ toggleWebCam }) => !!toggleWebCam,
  close: () => {}
})